module.exports = __webpack_public_path__ + "static/media/travel-bg-shape.9f36ad10.svg";